import { motion } from 'framer-motion'

interface Props { onResume: () => void; onStop: () => void }

export function PauseOverlay({ onResume, onStop }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <motion.div
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        className="text-6xl font-bold tracking-widest text-white mb-8"
      >
        PAUSED
      </motion.div>
      <div className="flex gap-4">
        <button
          onClick={onResume}
          className="px-8 py-3 bg-teal-500 hover:bg-teal-400 text-black font-bold rounded-xl text-lg active:scale-95 transition-all"
        >
          ▶ Resume
        </button>
        <button
          onClick={onStop}
          className="px-6 py-3 bg-[#21262d] hover:bg-rose-900 rounded-xl font-bold text-lg transition-all"
        >
          ✕ Stop
        </button>
      </div>
      <p className="mt-6 text-slate-400 text-sm">Press Space to resume</p>
    </motion.div>
  )
}
